import { render, staticRenderFns } from "./SimplePendulumViz.vue?vue&type=template&id=12c2d32a&scoped=true"
import script from "./SimplePendulumViz.vue?vue&type=script&lang=js"
export * from "./SimplePendulumViz.vue?vue&type=script&lang=js"
import style0 from "./SimplePendulumViz.vue?vue&type=style&index=0&id=12c2d32a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2d32a",
  null
  
)

export default component.exports